
import { useRef } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";

export default function TextInputField({label,definition,layoutObject,updateFunc,saveFunc,screenSize,validateURL}:AttributeFieldProps&{validateURL?:boolean}){

    let key = definition.attKey;

    const prevRef = useRef("");

    let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);
    
    const urlValidation = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

    const validateInput = (e:any)=>{
        e.target.value = e.target.value.replaceAll(" ","");
    
        if(!urlValidation.test(e.target.value)){
    
          
    
          let validLine =  e.target.parentElement?.querySelector("#invalid-message");
    
    
          if(validLine){
            if(e.target.value.length>0){
              (validLine as HTMLElement).style.display = "block";
              (validLine as HTMLElement).innerText = "Invalid URL";
              return false;
            }
            else{
              (validLine as HTMLElement).style.display = "none";
            }
          }
       
         
       
        }
        else{
        
          let validLine =  e.target.parentElement?.querySelector("#invalid-message");
          if(validLine){
            (validLine as HTMLElement).style.display = "none";
          }
        }
        return true;
    
      }

    prevRef.current = val;
    const inputRef = useRef(null);

    const triggerInput =(e:any)=>{

        if(inputRef.current){
            let current = inputRef.current as HTMLInputElement;
            let canUpdate = true;
            if(validateURL){
            

                if(current.value.startsWith("www."))
                {
                    current.value = "https://"+current.value;
                }

                if(!validateInput(e)) 
                canUpdate = false;
            }

            if(current && canUpdate){

                updateFunc(key,current.value,definition.targetType);

            }
        }
    }

    let range = definition.range;
    let maxRange = 300;
    if(range && range.max > 5){
        maxRange = range.max;
    }

    const TrySave = ()=>{
        //bluring usually happens at a state change so set a timeout to avoid issues
        setTimeout(()=>{
        if(inputRef.current){
            let current = inputRef.current as HTMLInputElement;
            if(current.value!=prevRef.current){
                prevRef.current = current.value;
                saveFunc();
            }
        }}
        ,10);
    }

return(

    <div className="wb-input-group">
    <label className={val==""?"not-updated":"updated"}>{label}</label>
    <div className="wb-input-row relative">
    <div id="invalid-message" style={{display:"none", color:"red",marginLeft:"8px",fontSize:"12px",position:"absolute",top:"64px",left:"-6px"}}>Invalid Url </div>
        <input type="text" defaultValue={val} maxLength={maxRange} ref={inputRef} onInput={triggerInput} placeholder={definition.placeHolder} onBlur={TrySave}/>
     
    </div>

    <div className="input-description">{definition.description}</div>

  
    </div>

)
}

